module.exports = __webpack_public_path__ + "Ico_share.png";